import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Signup.css';
import logo from "../../assets/logo.png";
import { Link } from 'react-router-dom';

const SignUp = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const validateForm = () => {
    if (!email || !password) {
      setError('All fields are required');
      return false;
    }
    setError('');
    return true;
  };

  const handleSignUp = async (event) => {
    event.preventDefault();
    if (!validateForm()) return;
    setLoading(true);

    try {
      const url = `${process.env.REACT_APP_API_URL}/api/auth/register`;

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'accept': 'application/json'
        },
        body: JSON.stringify({
          email: email,
          password: password
        }),
      });

      setLoading(false);

      const responseData = await response.json();

      if (response.ok && responseData.successful) {
        navigate('/login');
      } else {
        const errorMessage = responseData.error?.message || 
                             responseData.detail?.[0]?.msg ||
                             'Registration failed!';
        setError(errorMessage);
      }
    } catch (error) {
      setLoading(false);
      console.error('Error:', error);
      setError('An error occurred. Please try again later.');
    }
  };

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleSignUp}>
      <div className="form-group">
        <div className='flex w-full justify-center'>
          <img src={logo} alt="Logo" className="logo-image !h-9" />
        </div>
      </div>
        <h1 className='text-3xl font-bold my-6 text-center'>Create your account</h1>
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            className="form-input border"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            className="form-input border"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        {error && <p className="mb-4 text-red-500">{error}</p>}
        <div className='flex justify-end'>
          <button type="submit" disabled={loading} className='login-button py-2 px-4 mr-0 w-full'>
            {loading ? 'Signing up...' : 'Sign Up'}
          </button>
        </div>
        <div className='flex justify-center mt-4'>
          <p className='text-sm text-gray-500'>Already have an account? <Link to="/login" className='text-primary'>Log in</Link></p>
        </div>
      </form>
    </div>
  );
};

export default SignUp;
